
(function () {
  // The same bridge serves the unpublished Playground theme and the reviewed
  // production theme. Production can only post to the Danish checkout host.
  var preview = Boolean(window.MAXLAGER_KUSTOM_DK_PREVIEW);
  var config = window.MAXLAGER_KUSTOM_DK_PREVIEW || window.MAXLAGER_KUSTOM_DK;
  if (!config || location.hostname !== 'maxlager.dk' || String(window.Shopify?.theme?.id) !== String(config.themeId)) return;
  var endpoint;
  try { endpoint = new URL(config.checkoutUrl); } catch (_) { return; }
  if (endpoint.protocol !== 'https:' || endpoint.username || endpoint.password) return;
  if (!preview && (endpoint.href !== 'https://checkout.maxlager.dk/checkout' ||
      window.Shopify?.shop !== 'd1i505-bh.myshopify.com' || window.Shopify?.theme?.role !== 'main')) return;
  if (window.__maxlagerKustomDkBridgeInstalled) return;
  window.__maxlagerKustomDkBridgeInstalled = true;
  var KUSTOM_CHECKOUT_URL = endpoint.href;
  var FALLBACK_CHECKOUT_URL = "/checkout";
  var LD_ATTR_KEY = "__ld_attr";
  var TRACKING_STORAGE_KEY = "maxlager_kustom_tracking_params";
  var KACHING_HANDLER_FLAG = "__maxlagerKachingCheckoutHandlerInstalled";

  var FALLBACK_CHECKOUT_BUTTON_SELECTOR = [
    "#maxlager-kustom-checkout-button",
    "button[name='checkout']",
    "a[href='/checkout']",
    "a[href$='/checkout']"
  ].join(",");

  var KACHING_CHECKOUT_BUTTON_SELECTOR = [
    ".kaching-cart__checkout-button",
    "[data-kaching-checkout]"
  ].join(",");


  function failToShopifyCheckout(error) {
    console.error("Kustom checkout failed, redirecting to Shopify checkout:", error);
    window.location.href = FALLBACK_CHECKOUT_URL;
  }

  function getShopifyRoot() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root;
    }

    return "/";
  }

  function getCookie(name) {
    var escapedName = name.replace(/[.$?*|{}()[\]\\/+^]/g, "\\$&");
    var match = document.cookie.match(new RegExp("(^|; )" + escapedName + "=([^;]*)"));
    return match ? decodeURIComponent(match[2]) : "";
  }

  function hasKeys(object) {
    return object && Object.keys(object).length > 0;
  }

  function getUrlTrackingParams() {
    var params = new URLSearchParams(window.location.search);
    var data = {};

    params.forEach(function (value, key) {
      if (
        key === "gclid" ||
        key === "gbraid" ||
        key === "wbraid" ||
        key === "fbclid" ||
        key.indexOf("utm_") === 0
      ) {
        data[key] = value;
      }
    });

    return data;
  }

  function getStoredTrackingParams() {
    try {
      return JSON.parse(sessionStorage.getItem(TRACKING_STORAGE_KEY) || "{}");
    } catch (e) {
      return {};
    }
  }

  function getTrackingParams() {
    var current = getUrlTrackingParams();

    if (hasKeys(current)) {
      try {
        sessionStorage.setItem(TRACKING_STORAGE_KEY, JSON.stringify(current));
      } catch (e) {}

      return current;
    }

    return getStoredTrackingParams();
  }

  function getTrackingParam(name, trackingParams) {
    var fromUrl = new URLSearchParams(window.location.search).get(name);

    if (fromUrl) return fromUrl;
    if (trackingParams && trackingParams[name]) return trackingParams[name];

    return "";
  }

  function parseGclCookie(value) {
    if (!value) return "";

    var parts = value.split(".");
    return parts.length >= 3 ? parts.slice(2).join(".") : value;
  }

  function getGoogleClientId() {
    var gaCookie = getCookie("_ga");

    if (!gaCookie) return "";

    var parts = gaCookie.split(".");

    if (parts.length >= 4) {
      return parts[2] + "." + parts[3];
    }

    return gaCookie;
  }

  function getGa4SessionCookie() {
    var cookies = document.cookie.split(";").map(function (cookie) {
      return cookie.trim();
    });

    var ga4Cookie = cookies.find(function (cookie) {
      return cookie.indexOf("_ga_") === 0;
    });

    if (!ga4Cookie) return "";

    return decodeURIComponent(ga4Cookie.split("=").slice(1).join("="));
  }

  function getGoogleAdsData(trackingParams) {
    var googleAds = {};

    var gclid =
      getTrackingParam("gclid", trackingParams) ||
      parseGclCookie(getCookie("_gcl_aw"));

    var gbraid =
      getTrackingParam("gbraid", trackingParams) ||
      parseGclCookie(getCookie("_gcl_gb"));

    var wbraid =
      getTrackingParam("wbraid", trackingParams) ||
      parseGclCookie(getCookie("_gcl_wb"));

    if (gclid) googleAds.gclid = gclid;
    if (gbraid) googleAds.gbraid = gbraid;
    if (wbraid) googleAds.wbraid = wbraid;

    return googleAds;
  }

  function getFacebookData(trackingParams) {
    var facebook = {};

    var fbp = getCookie("_fbp");
    var fbc = getCookie("_fbc");
    var fbclid = getTrackingParam("fbclid", trackingParams);

    if (!fbc && fbclid) {
      fbc = "fb.1." + Date.now() + "." + fbclid;
    }

    if (fbp) facebook.fbp = fbp;
    if (fbc) facebook.fbc = fbc;

    return facebook;
  }

  function getUtmData(trackingParams) {
    var utm = {};
    var keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

    keys.forEach(function (key) {
      var value = getTrackingParam(key, trackingParams);
      if (value) utm[key] = value;
    });

    return utm;
  }

  function getClientHints() {
    return {
      isMobile: /Mobi|Android/i.test(navigator.userAgent),
      platform: navigator.platform || ""
    };
  }

  function getConsentData() {
    try {
      if (
        window.Shopify &&
        Shopify.customerPrivacy &&
        typeof Shopify.customerPrivacy.currentVisitorConsent === "function"
      ) {
        var consent = Shopify.customerPrivacy.currentVisitorConsent();

        return {
          marketing: consent.marketing || "",
          analytics: consent.analytics || "",
          preferences: consent.preferences || "",
          sale_of_data: consent.sale_of_data || ""
        };
      }
    } catch (e) {}

    return {
      marketing: "",
      analytics: "",
      preferences: "",
      sale_of_data: ""
    };
  }

  function base64EncodeUnicode(value) {
    return btoa(unescape(encodeURIComponent(value)));
  }

  function buildLittledataAttribute() {
    var trackingParams = getTrackingParams();
    var payload = {};

    var facebook = getFacebookData(trackingParams);
    if (hasKeys(facebook)) {
      payload.facebook = facebook;
    }

    var googleAds = getGoogleAdsData(trackingParams);
    if (hasKeys(googleAds)) {
      payload.googleAds = googleAds;
    }

    var cid = getGoogleClientId();
    var sid = getGa4SessionCookie();

    if (cid || sid) {
      payload.googleAnalytics4 = {};
      if (cid) payload.googleAnalytics4.cid = cid;
      if (sid) payload.googleAnalytics4.sid = sid;
    }

    var utm = getUtmData(trackingParams);
    if (hasKeys(utm)) {
      payload.utm = utm;
    }

    payload.clientHints = getClientHints();

    payload.pageInfo = {
      page_referrer: document.referrer || "",
      language: (navigator.language || "").toLowerCase(),
      language_iso: (navigator.language || "").split("-")[0].toLowerCase(),
      country_iso: "DK",
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
      screen: {
        width: String(window.screen.width || ""),
        height: String(window.screen.height || ""),
        density: String(window.devicePixelRatio || "")
      }
    };

    if (window.Shopify && Shopify.country) {
      payload.pageInfo.country_iso = Shopify.country;
    }

    payload.userConsent = getConsentData();
    payload.userAgent = navigator.userAgent || "";

    return base64EncodeUnicode(JSON.stringify(payload));
  }

  function buildTrackingAttributes(existing) {
    var attributes = {};
    var ldAttr = buildLittledataAttribute();
    var googleClientId = getGoogleClientId();

    // Littledata may already have written a richer attribution payload. Keep
    // its identifiers and fields rather than replacing them with our fallback.
    // Current consent is authoritative, including withdrawal since cart load.
    if (existing && typeof existing[LD_ATTR_KEY] === 'string') {
      try {
        var nativePayload = JSON.parse(decodeURIComponent(escape(atob(existing[LD_ATTR_KEY]))));
        var fallbackPayload = JSON.parse(decodeURIComponent(escape(atob(ldAttr))));
        if (nativePayload && typeof nativePayload === 'object' && !Array.isArray(nativePayload)) {
          var merged = Object.assign({}, fallbackPayload, nativePayload);
          ['facebook', 'googleAds', 'googleAnalytics4', 'utm'].forEach(function (key) {
            if (nativePayload[key] && typeof nativePayload[key] === 'object' && !Array.isArray(nativePayload[key])) {
              merged[key] = Object.assign({}, fallbackPayload[key] || {}, nativePayload[key]);
            }
          });
          merged.userConsent = fallbackPayload.userConsent;
          ldAttr = base64EncodeUnicode(JSON.stringify(merged));
        }
      } catch (_) { /* Invalid legacy data must not prevent checkout. */ }
    }
    attributes[LD_ATTR_KEY] = ldAttr;

    if (googleClientId) {
      attributes["google-clientID"] = googleClientId;
    }

    return attributes;
  }

  async function fetchCart() {
    var response = await fetch(getShopifyRoot() + "cart.js", {
      method: "GET",
      signal: AbortSignal.timeout(5000),
      headers: {
        "Accept": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error("Could not fetch Shopify cart");
    }

    return response.json();
  }

  async function updateShopifyCartAttributes(attributes) {
    try {
      await fetch(getShopifyRoot() + "cart/update.js", {
        method: "POST",
        signal: AbortSignal.timeout(1500),
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          attributes: attributes
        })
      });
    } catch (error) {
      console.warn("Could not update Shopify cart attributes. Continuing with cart_json payload.", error);
    }
  }

  function centsToAmount(value) {
    return Math.round(Number(value || 0)) / 100;
  }

  function firstDefinedValue(object, keys) {
    if (!object) return 0;

    for (var i = 0; i < keys.length; i += 1) {
      if (
        Object.prototype.hasOwnProperty.call(object, keys[i]) &&
        object[keys[i]] !== null &&
        object[keys[i]] !== undefined &&
        object[keys[i]] !== ""
      ) {
        return object[keys[i]];
      }
    }

    return 0;
  }

  function absoluteUrl(value) {
    if (!value) return "";

    value = String(value);

    if (value.indexOf("http://") === 0 || value.indexOf("https://") === 0) {
      return value;
    }

    if (value.indexOf("//") === 0) {
      return window.location.protocol + value;
    }

    if (value.indexOf("/") === 0) {
      return window.location.origin + value;
    }

    return value;
  }

  function getLineItemImageUrl(item) {
    if (!item) return "";

    if (item.image) {
      return absoluteUrl(item.image);
    }

    if (item.featured_image && item.featured_image.url) {
      return absoluteUrl(item.featured_image.url);
    }

    if (item.featured_image && item.featured_image.src) {
      return absoluteUrl(item.featured_image.src);
    }

    return "";
  }
  function base64UrlEncodeUnicode(value) {
    return base64EncodeUnicode(value)
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/g, "");
  }

  function hasKachingCartProperty(item) {
    return !!(
      item &&
      item.properties &&
      Object.prototype.hasOwnProperty.call(item.properties, "_kaching_cart") &&
      item.properties._kaching_cart
    );
  }

  function getRecoveryCartItems(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return [];
    }

    return cart.items.slice().sort(function (a, b) {
      var aGift = hasKachingCartProperty(a) ? 0 : 1;
      var bGift = hasKachingCartProperty(b) ? 0 : 1;

      return aGift - bGift;
    });
  }

  function buildLineItemPropertiesParam(item) {
    try {
      if (!hasKachingCartProperty(item)) {
        return "";
      }

      return base64UrlEncodeUnicode(JSON.stringify({
        _kaching_cart: item.properties._kaching_cart
      }));
    } catch (error) {
      console.warn("Could not encode Kaching gift properties for Shopify recovery checkout URL", error);
      return "";
    }
  }
    function buildShopifyRecoveryCheckoutUrl(cart) {
    try {
      if (!cart || !cart.items || !cart.items.length) {
        return window.location.origin + FALLBACK_CHECKOUT_URL;
      }

      var recoveryItems = getRecoveryCartItems(cart);

      var cartItems = recoveryItems
        .filter(function (item) {
          return item && item.id && item.quantity;
        })
        .map(function (item) {
          return String(item.id) + ":" + String(item.quantity);
        })
        .join(",");

      if (!cartItems) {
        return window.location.origin + FALLBACK_CHECKOUT_URL;
      }

      var queryParts = [
        "utm_source=klaviyo",
        "utm_medium=flow",
        "utm_campaign=started_checkout_recovery",
        "utm_content=kustom_started_checkout"
      ];

      var propertiesParam = buildLineItemPropertiesParam(recoveryItems[0]);

      if (propertiesParam) {
        queryParts.unshift("properties=" + propertiesParam);
      }

      return (
        window.location.origin +
        "/cart/" +
        cartItems +
        "?" +
        queryParts.join("&")
      );
    } catch (error) {
      console.warn("Could not build Shopify recovery checkout URL. Using default Shopify checkout.", error);
      return window.location.origin + FALLBACK_CHECKOUT_URL;
    }
  }

  function buildKlaviyoLineItems(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      return [];
    }

    return cart.items.map(function (item) {
      var productUrl = absoluteUrl(item.url || "");
      var imageUrl = getLineItemImageUrl(item);
      var productName = item.product_title || item.title || "";
      var itemPrice = centsToAmount(firstDefinedValue(item, ["final_price", "price"]));
      var rowTotal = centsToAmount(firstDefinedValue(item, ["final_line_price", "line_price"]));
      var originalRowTotal = centsToAmount(firstDefinedValue(item, ["original_line_price", "line_price"]));

      return {
        ProductID: String(item.product_id || ""),
        VariantID: String(item.id || ""),
        SKU: item.sku || "",
        ProductName: productName,
        Quantity: Number(item.quantity || 0),
        ItemPrice: itemPrice,
        RowTotal: rowTotal,
        OriginalRowTotal: originalRowTotal,
        ProductURL: productUrl,
        ImageURL: imageUrl,
        ProductCategories: item.product_type ? [item.product_type] : [],
        VariantTitle: item.variant_title || "",
        Vendor: item.vendor || ""
      };
    });
  }

  function buildKlaviyoExtraLineItems(cart, klaviyoItems) {
    var cartItems = cart && cart.items ? cart.items : [];

    return klaviyoItems.map(function (item, index) {
      var cartItem = cartItems[index] || {};

      return {
        id: cartItem.key || item.VariantID,
        key: cartItem.key || "",
        product_id: item.ProductID,
        variant_id: item.VariantID,
        sku: item.SKU,
        title: cartItem.title || item.ProductName,
        product_title: item.ProductName,
        variant_title: item.VariantTitle,
        quantity: item.Quantity,
        price: item.ItemPrice,
        line_price: item.RowTotal,
        final_price: item.ItemPrice,
        final_line_price: item.RowTotal,
        original_line_price: item.OriginalRowTotal,
        compare_at_price: cartItem.compare_at_price ? centsToAmount(cartItem.compare_at_price) : 0,
        url: item.ProductURL,
        image: item.ImageURL,
        image_url: item.ImageURL,
        featured_image: {
          url: item.ImageURL,
          src: item.ImageURL,
          alt: item.ProductName
        },
        product: {
          id: item.ProductID,
          title: item.ProductName,
          url: item.ProductURL,
          handle: cartItem.handle || "",
          vendor: item.Vendor,
          type: cartItem.product_type || ""
        },
        properties: cartItem.properties || {}
      };
    });
  }

  function buildKlaviyoStartedCheckoutPayload(cart) {
    var checkoutUrl = buildShopifyRecoveryCheckoutUrl(cart);
    var items = buildKlaviyoLineItems(cart);
    var extraLineItems = buildKlaviyoExtraLineItems(cart, items);
    var categories = [];

    items.forEach(function (item) {
      (item.ProductCategories || []).forEach(function (category) {
        if (category && categories.indexOf(category) === -1) {
          categories.push(category);
        }
      });
    });

    return {
      "$event_id": "kustom_started_checkout_" + String(cart && cart.token ? cart.token : Date.now()) + "_" + String(Math.floor(Date.now() / 1000)),
      "$value": centsToAmount(cart && cart.total_price),
      value_currency: "DKK",
      CheckoutURL: checkoutUrl,
      ItemNames: items.map(function (item) {
        return item.ProductName;
      }),
      Categories: categories,
      Items: items,
      source: "kustom",
      recovery_checkout: "shopify",

      extra: {
        checkout_url: checkoutUrl,
        line_items: extraLineItems
      }
    };
  }

  function pushKlaviyoStartedCheckout(payload) {
    if (window.klaviyo && typeof window.klaviyo.track === "function") {
      return window.klaviyo.track("Started Checkout", payload);
    }

    if (window._learnq && typeof window._learnq.push === "function") {
      window._learnq.push(["track", "Started Checkout", payload]);
      return true;
    }

    if (Array.isArray(window.klaviyo)) {
      window.klaviyo.push(["track", "Started Checkout", payload]);
      return true;
    }

    console.warn("Klaviyo Started Checkout skipped: Klaviyo tracker is not available");
    return false;
  }

  async function trackKlaviyoStartedCheckout(cart) {
    try {
      if (!cart || !cart.items || !cart.items.length) {
        return;
      }

      var payload = buildKlaviyoStartedCheckoutPayload(cart);
      var result = pushKlaviyoStartedCheckout(payload);

      if (result && typeof result.then === "function") {
        await Promise.race([
          result,
          new Promise(function (resolve) {
            window.setTimeout(resolve, 700);
          })
        ]);
      } else {
        await new Promise(function (resolve) {
          window.setTimeout(resolve, 250);
        });
      }

    } catch (error) {
      console.warn("Klaviyo Started Checkout failed. Continuing to Kustom checkout.", error);
    }
  }

  // Maxlager checkout back-navigation recovery v1
  var checkoutButtonBeforeNavigation = null;
  window.addEventListener("pageshow", function (event) {
    if (!event.persisted) return;
    window.__maxlagerKustomCheckoutSubmitting = false;
    var previous = checkoutButtonBeforeNavigation;
    if (previous) {
      if (previous.ariaDisabled === null) previous.button.removeAttribute("aria-disabled");
      else previous.button.setAttribute("aria-disabled", previous.ariaDisabled);
      if (previous.button.tagName === "BUTTON") previous.button.disabled = previous.disabled;
      if (previous.button.id === "maxlager-kustom-checkout-button") previous.button.textContent = previous.text;
      checkoutButtonBeforeNavigation = null;
    }
    document.querySelectorAll("form[data-maxlager-kustom-checkout]").forEach(function (form) { form.remove(); });
  });

  async function goToKustomCheckout(button) {
    if (window.__maxlagerKustomCheckoutSubmitting) {
      return;
    }

    checkoutButtonBeforeNavigation = button ? {
      button: button, disabled: button.disabled,
      ariaDisabled: button.getAttribute("aria-disabled"), text: button.textContent
    } : null;
    window.__maxlagerKustomCheckoutSubmitting = true;


    if (button) {
      button.setAttribute("aria-disabled", "true");

      if (button.tagName === "BUTTON") {
        button.disabled = true;
      }

      if (button.id === "maxlager-kustom-checkout-button") {
        button.textContent = "Indlæser kassen...";
      }
    }

    var cart = await fetchCart();

    if (cart.currency !== "DKK") throw new Error("Unexpected cart currency");
    var trackingAttributes = {};
    try { trackingAttributes = buildTrackingAttributes(cart.attributes); }
    catch (_) { /* Analytics failure must never block a customer's checkout. */ }
    cart.attributes = Object.assign({}, cart.attributes || {}, trackingAttributes);

    if (!cart.items || cart.items.length === 0) {
      window.__maxlagerKustomCheckoutSubmitting = false;

      alert("Din indkøbskurv er tom.");

      if (button) {
        button.removeAttribute("aria-disabled");

        if (button.tagName === "BUTTON") {
          button.disabled = false;
        }

        if (button.id === "maxlager-kustom-checkout-button") {
          button.textContent = "Kustom Checkout";
        }
      }

      return;
    }

    // Also preserve attributes on Shopify's fallback checkout. A failed or slow
    // cart update cannot lose attribution from the cart_json sent to Kustom.
    if (hasKeys(trackingAttributes)) await updateShopifyCartAttributes(trackingAttributes);

    var form = document.createElement("form");
    form.method = "POST";
    form.action = KUSTOM_CHECKOUT_URL;
    form.setAttribute("data-maxlager-kustom-checkout", "true");

    var input = document.createElement("input");
    input.type = "hidden";
    input.name = "cart_json";
    input.value = JSON.stringify(cart);

    form.appendChild(input);
    document.body.appendChild(form);

    form.submit();
  }

  function isKachingHandlerInstalled() {
    return window[KACHING_HANDLER_FLAG] === true;
  }

  function installKachingCheckoutHandler() {
    if (isKachingHandlerInstalled()) {
      return true;
    }

    if (
      !window.kachingCartApi ||
      typeof window.kachingCartApi.setCheckoutButtonClickHandler !== "function"
    ) {
      return false;
    }

    window.kachingCartApi.setCheckoutButtonClickHandler(function (event) {
      if (event && typeof event.preventDefault === "function") {
        event.preventDefault();
      }

      if (event && typeof event.stopPropagation === "function") {
        event.stopPropagation();
      }

      goToKustomCheckout(null).catch(function (error) {
        failToShopifyCheckout(error);
      });

      return false;
    });

    window[KACHING_HANDLER_FLAG] = true;

    return true;
  }

  function findFallbackCheckoutButton(target) {
    if (!target || typeof target.closest !== "function") {
      return null;
    }

    var fallbackButton = target.closest(FALLBACK_CHECKOUT_BUTTON_SELECTOR);

    if (fallbackButton) {
      return fallbackButton;
    }

    if (isKachingHandlerInstalled()) {
      return null;
    }

    var kachingButton = target.closest(KACHING_CHECKOUT_BUTTON_SELECTOR);

    if (kachingButton) {
      return kachingButton;
    }

    var genericButton = target.closest("button, a");

    if (!genericButton) {
      return null;
    }

    var text = String(genericButton.textContent || "").toLowerCase();

    if (
      text.indexOf("til kassen") !== -1 ||
      text.indexOf("checkout") !== -1 ||
      text.indexOf("gå til betaling") !== -1
    ) {
      return genericButton;
    }

    return null;
  }

  function bindKachingHandlerWhenReady() {
    if (installKachingCheckoutHandler()) {
      return;
    }

    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts += 1;

      if (installKachingCheckoutHandler() || attempts >= 40) {
        window.clearInterval(interval);
      }
    }, 500);
  }

  // Save landing-page campaign parameters before the shopper changes pages.
  try { getTrackingParams(); } catch (_) { /* Storage can be unavailable. */ }
  bindKachingHandlerWhenReady();

  document.addEventListener("click", function (event) {
    var button = findFallbackCheckoutButton(event.target);

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    goToKustomCheckout(button).catch(function (error) {
      failToShopifyCheckout(error);
    });
  }, true);
})();
